export const API_URL = '/api';

export const DEFAULT_IMG = '/assets/images/ou-default.png';



// WEBPACK FOOTER //
// ./src/utils/constants.js